import { Action } from '@ngrx/store';
import { ActionOptionsArgs, BaseAction, SynchronisableAction } from '../../../core/store/actions/base-actions';
import { BaseObjectFilters } from '../../store/bootstrap';
import { TaskType } from './task-type.model';

export const ENTITY = 'taskType';
export const REHYDRATE = '[TaskType] Rehydrate';
export const REMOVE = '[TaskType] Remove';
export const SUBMIT = '[TaskType] Submit';
export const SET_FILTER = '[TaskType] Set Filter';

export class SubmitAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = SUBMIT;

    constructor(public payload: TaskType, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class RehydrateAction implements Action {
    readonly type = REHYDRATE;

    constructor(public payload: Array<TaskType>) {

    }
}
export class RemoveAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = REMOVE;

    constructor(public payload: TaskType, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class SetFilterAction extends BaseAction {
    readonly type = SET_FILTER;
    readonly entity = ENTITY;

    constructor(public payload: BaseObjectFilters, options?: ActionOptionsArgs) {
        super(payload, options);
    }
}

export type Actions
    = SubmitAction
    | RehydrateAction
    | RemoveAction
    | SetFilterAction;



// WEBPACK FOOTER //
// ./src/vas/business-objects/task-type/task-type.actions.ts